import { render, staticRenderFns } from "./FooterServices.vue?vue&type=template&id=2d85dca8&"
import script from "./FooterServices.vue?vue&type=script&lang=js&"
export * from "./FooterServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports